import Modal from './Modal.container'

export default Modal
